export default {
  article: {
    breadcrumb: {
      home: "Forside",
    },
    author: "Redaktionelt team",
    updated: "Sidst opdateret",
    cta: {
      title: "Begynd at udforske spreadsheetet",
      text: "Klar til at browse? Gå tilbage til forsiden for at vælge en kategori, eller besøg hovedsiden for at fortsætte med at shoppe.",
      primary: "Gennemse kategorier",
      secondary: "Besøg hovedsiden",
    },
    related: {
      title: "Relaterede ressourcer",
      homeCard: "AllChinaBuy Spreadsheet Hub",
      homeDesc: "Gennemse alle kategorier, guider og ressourcer på ét sted.",
    },
    tipsTitle: "Nøgletips",
    faqTitle: "Ofte stillede spørgsmål",
    disclaimer:
      "Dette er en uafhængig informationswebsite og er ikke tilknyttet eller godkendt af AllChinaBuy, medmindre det udtrykkeligt er angivet. Oplysninger kan ændre sig, så brugere bør bekræfte aktuelle vilkår, priser, forsendelsesbetingelser og politikker, før de beslutter sig.",
    notFound: {
      title: "Guide ikke fundet",
      text: "Vi kunne ikke finde den guide, du ledte efter.",
      back: "Tilbage til forsiden",
    },
    content: {
      "allchinabuy-spreadsheet": {
        title: "AllChinaBuy Spreadsheet: Den komplette guide",
        subtitle:
          "En praktisk og original guide til at forstå og bruge et AllChinaBuy spreadsheet — fra hvad det er, til de tips der hjælper dig med at finde bedre produkter hurtigere.",
        metaTitle: "AllChinaBuy Spreadsheet: Den komplette guide til bedre fund",
        metaDescription:
          "Lær hvad et AllChinaBuy spreadsheet er, hvordan du bruger det, hvilke kategorier du skal udforske, og de tips der hjælper dig med at finde bedre produkter hurtigere.",
        metaKeywords:
          "AllChinaBuy spreadsheet, AllChinaBuy fund, AllChinaBuy guide, AllChinaBuy købsguide",
        tag: "Komplet guide",
        readTime: "6 min læsning",
        intro: [
          "Hvis du nogensinde har ledt efter produkter til international forsendelse, har du sandsynligvis mødt idéen om et AllChinaBuy spreadsheet. Kort sagt er det en måde at skabe orden i søgningen på — ved at samle produktlinks, kategorier, sælgernoter og kvalitetstjek i ét letlæseligt sted.",
          "Denne guide forklarer, hvad et AllChinaBuy spreadsheet er, hvorfor købere bruger det, hvordan du kommer i gang, og de praktiske tips der gør processen lettere. Uanset om du er ny eller erfaren, er målet det samme: find det du vil have med mindre scrollen og mere selvtillid.",
        ],
        sections: [
          {
            h: "Hvad er et AllChinaBuy spreadsheet?",
            p: [
              "Et AllChinaBuy spreadsheet er i bund og grund en organiseret liste. Det grupperer produkter efter kategori — sko, hættetrøjer, t-shirts, tasker og mere — og knytter nyttige oplysninger til hver post, såsom et produktlink, en kort beskrivelse, sælgernoter og om kvalitetstjek er udført.",
              "Tænk på det som en personlig research-tavle. I stedet for at holde snesevis af faner åbne, holder du vigtige links og noter i én struktureret visning. Den struktur er det, der gør det nyttigt: du kan scanne, sammenligne og genbesøge varer uden at miste overblikket.",
            ],
          },
          {
            h: "Hvorfor købere bruger et spreadsheet",
            p: [
              "Hovedårsagen er klarhed. At gennemse et stort katalog kan hurtigt blive overvældende. Et spreadsheet reducerer støjen ved kun at vise de varer og detaljer, du bekymrer dig om.",
              "Den anden årsag er hastighed. Når dine fund allerede er organiseret, tager det ét klik at skifte fra et par sneakers til en hættetrøje til en taske. Endelig hjælper et spreadsheet dig med at holde en oversigt — din liste venter, hvis du bestiller senere.",
            ],
          },
          {
            h: "Sådan bruger du et AllChinaBuy spreadsheet",
            p: [
              "Vælg først en kategori — sko, hættetrøjer, t-shirts, jakker eller en anden gruppe. Hver kategori linker direkte til et matchende udvalg på hovedsiden.",
              "Gennemse derefter varerne og læg mærke til dem, der skiller sig ud. Vær opmærksom på kvalitetstjek eller anmeldelser, da det ofte er forskellen mellem et godt fund og en skuffelse.",
              "Åbn til sidst hovedsiden og gennemfør dit køb. Du behøver ingen særlige værktøjer — bare lidt organisering og de links, der allerede er samlet.",
            ],
          },
          {
            h: "Populære kategorier at udforske",
            p: [
              "AllChinaBuy spreadsheet dækker typisk et bredt udvalg af tøj og tilbehør: sko, hættetrøjer og sweatshirts, t-shirts, jakker, bukser og shorts, hovedbeklædning, sæt, undertøj, trøjer, tilbehør, tasker, bælter og parfumer plus en opsamlingskategori.",
              "Hver kategori på dette site linker til det tilsvarende udvalg på hovedsiden, så du kan gå direkte fra oversigten til det fulde katalog.",
            ],
          },
        ],
        tips: [
          {
            t: "Start med én kategori",
            d: "Fokuser på én kategori ad gangen for at sammenligne lignende varer uden at fare vild.",
          },
          {
            t: "Tjek QC- og anmeldelsesnoter",
            d: "Læs kvalitetstjek eller anmeldelser, når de findes, før du beslutter dig.",
          },
          {
            t: "Hold en kortliste",
            d: "Notér dine favoritter, og genbesøg listen før du bestiller.",
          },
          {
            t: "Bekræft forsendelse og priser",
            d: "Omkostninger ændrer sig, så bekræft aktuelle detaljer på hovedsiden.",
          },
          {
            t: "Vurder sælgere selv",
            d: "Brug sælgeroplysninger som udgangspunkt, og lav altid din egen research.",
          },
        ],
        faq: [
          {
            q: "Er AllChinaBuy spreadsheet gratis at bruge?",
            a: "Dette site er en uafhængig informationsressource, og kategorilinkene er gratis at gennemse. Køb sker på hovedsiden.",
          },
          {
            q: "Skal jeg have en konto?",
            a: "Nej, der kræves ingen konto for at gennemse kategorier og guider på dette site.",
          },
          {
            q: "Holdes kategorilinkene opdateret?",
            a: "Linkene peger på hovedsidens kategorisider, som er den mest aktuelle kilde.",
          },
          {
            q: "Er dette det officielle AllChinaBuy-site?",
            a: "Nej. Dette er en uafhængig ressource og er ikke tilknyttet eller godkendt af AllChinaBuy.",
          },
        ],
      },
      "allchinabuy-finds": {
        title: "AllChinaBuy Fund: Find bedre produkter hurtigere",
        subtitle:
          "En enkel og gentagelig metode til at finde gode AllChinaBuy-fund i hver kategori uden endeløs scrollen.",
        metaTitle: "AllChinaBuy Fund: Find bedre produkter hurtigere",
        metaDescription:
          "Opdag en enkel metode til at finde bedre AllChinaBuy-produkter. Lær at spotte gode fund, bruge QC og bygge en kortliste.",
        metaKeywords:
          "AllChinaBuy fund, AllChinaBuy produktfund, bedste AllChinaBuy fund",
        tag: "Fundguide",
        readTime: "5 min læsning",
        intro: [
          "At finde gode produkter på en stor platform kan føles som at lede efter en nål i en høstak. Tricket er ikke at se flere varer — det er at se de rigtige varer på en struktureret måde.",
          "Denne korte guide gennemgår en gentagelig metode til at finde gode AllChinaBuy-fund, fra valg af kategori til at bygge en kortliste, du faktisk stoler på.",
        ],
        sections: [
          {
            h: "Start med en klar intention",
            p: [
              "Før du browser, så beslut hvad du faktisk leder efter. Et vagt mål fører til spredt browsing, mens et præcist mål straks indsnævrer dit fokus.",
            ],
          },
          {
            h: "Brug kategorier til at indsnævre",
            p: [
              "Kategorier er din bedste genvej. I stedet for ét søgeord på tværs af hele siden, hop ind i en kategori som sko, tasker eller tilbehør.",
            ],
          },
          {
            h: "Filtrér fund med QC og noter",
            p: [
              "Forskellen på et okay og et godt fund er detaljen. Se efter varer med kvalitetstjek-fotos eller klare sælgernoter, og spring over det der virker vagt.",
            ],
          },
        ],
        tips: [
          {
            t: "Én kategori ad gangen",
            d: "At blive i én kategori gør dine sammenligninger meningsfulde.",
          },
          {
            t: "Se efter detaljerede opslag",
            d: "Flere detaljer nu betyder færre overraskelser senere.",
          },
          {
            t: "Gem, og gennemgå derefter",
            d: "Saml kandidater først, og trim listen før du bestiller.",
          },
        ],
        faq: [
          {
            q: "Hvordan finder jeg de bedste AllChinaBuy-fund?",
            a: "Start med et klart mål, gennemse en bestemt kategori, og foretræk opslag med QC-fotos og detaljerede noter.",
          },
          {
            q: "Er fundene på dette site kuraterede?",
            a: "Kategorierne linker til hovedsidens egne udvalg, som er den mest aktuelle kilde.",
          },
          {
            q: "Hvor ofte skal jeg tjekke for nye fund?",
            a: "Regelmæssigt, da tilgængelighed og lager ændrer sig på hovedsiden.",
          },
        ],
      },
      "allchinabuy-review": {
        title: "AllChinaBuy-anmeldelse: Funktioner, fordele og grænser",
        subtitle:
          "Et ærligt og praktisk overblik over, hvad en platform som AllChinaBuy tilbyder — dens styrker, grænser og hvad du bør tjekke før du bestiller.",
        metaTitle: "AllChinaBuy-anmeldelse: Funktioner, fordele og grænser",
        metaDescription:
          "En praktisk AllChinaBuy-anmeldelse om funktioner, fordele, grænser og hvad du bør tjekke før bestilling. Uafhængig og afbalanceret.",
        metaKeywords:
          "AllChinaBuy anmeldelse, AllChinaBuy platform anmeldelse, AllChinaBuy ærlig anmeldelse",
        tag: "Anmeldelse",
        readTime: "7 min læsning",
        intro: [
          "Før du bruger en købstjeneste, hjælper det at forstå, hvad den faktisk gør — og ikke gør. Denne anmeldelse gennemgår de typiske funktioner i en platform som AllChinaBuy i enkle vendinger.",
          "Vi holder den bevidst afbalanceret. En god anmeldelse handler ikke om hype; den hjælper dig med at se både fordele og grænser klart, før du forpligter dig.",
        ],
        sections: [
          {
            h: "Hvad AllChinaBuy er bygget til",
            p: [
              "AllChinaBuy er en købsplatform, der hjælper med at gennemse produkter, administrere køb og arrangere international forsendelse. Kerneværdien er bekvemmelighed — alt samlet ét sted.",
            ],
          },
          {
            h: "Fordelene",
            p: [
              "De vigtigste styrker er organisering og udvalg. Kategorier giver hurtig browsing, kvalitetstjek giver tillid, og et bredt katalog giver masser af valg.",
            ],
          },
          {
            h: "Grænserne at huske",
            p: [
              "Ingen platform fjerner al risiko. Forsendelsesomkostninger varierer, kvalitet afhænger af sælgere, og politikker ændrer sig. Platformen er et værktøj — resultatet afhænger af din egen omhu.",
            ],
          },
        ],
        tips: [
          {
            t: "Se anmeldelser som udgangspunkt",
            d: "Forstå det grundlæggende, og bekræft derefter detaljer selv.",
          },
          {
            t: "Tjek politikker før bestilling",
            d: "Forsendelses- og refusionsvilkår ændrer sig.",
          },
          {
            t: "Sammenlign før du forpligter dig",
            d: "Brug kategorier og QC til at sammenligne.",
          },
        ],
        faq: [
          {
            q: "Er AllChinaBuy en god platform?",
            a: "Den tilbyder nyttig organisering og udvalg, men resultatet afhænger af din egen omhu.",
          },
          {
            q: "Hvad er de vigtigste funktioner?",
            a: "Kategoribrowsing, køb, kvalitetstjek og international forsendelse.",
          },
          {
            q: "Er der ulemper?",
            a: "Omkostninger varierer, kvalitet afhænger af sælgere, og politikker udvikler sig.",
          },
        ],
      },
      "allchinabuy-shipping-cost": {
        title: "AllChinaBuy forsendelsesomkostning: Metoder, estimater og tips",
        subtitle:
          "Forstå hvad der driver AllChinaBuy forsendelsesomkostning, og hvordan du estimerer den, så der ikke er overraskelser ved kassen.",
        metaTitle: "AllChinaBuy forsendelsesomkostning: Metoder, estimater og tips",
        metaDescription:
          "En klar guide til AllChinaBuy forsendelsesomkostning. Lær hvad der påvirker prisen, almindelige metoder og tips til at estimere din total.",
        metaKeywords:
          "AllChinaBuy forsendelsesomkostning, AllChinaBuy forsendelsespris, AllChinaBuy forsendelsesestimat",
        tag: "Forsendelsesguide",
        readTime: "6 min læsning",
        intro: [
          "Forsendelse er ofte den del af en international ordre, der overrasker. Den gode nyhed er, at omkostningen ikke er et mysterium — den drives af nogle få faktorer, du kan forstå på få minutter.",
          "Denne guide forklarer, hvad der påvirker AllChinaBuy forsendelsesomkostning, de almindelige metoder og enkle måder at estimere din total på.",
        ],
        sections: [
          {
            h: "Hvad påvirker omkostningen",
            p: [
              "Tre ting betyder mest: destinationsland, samlet vægt og dimensioner samt den valgte metode. Hurtigere linjer og tungere pakker koster mere, økonomilinjer holder prisen nede.",
            ],
          },
          {
            h: "Almindelige forsendelsesmetoder",
            p: [
              "De fleste platforme tilbyder alt fra budgetøkonomi til hurtige ekspreslinjer. Økonomi er billigere men langsommere, ekspres ankommer hurtigere til en højere pris.",
            ],
          },
          {
            h: "Sådan estimerer du din total",
            p: [
              "Det mest pålidelige er at tjekke aktuelle priser på hovedsiden for dine varer og destination. Tungere varer og fjernere destinationer øger generelt omkostningen.",
            ],
          },
        ],
        tips: [
          {
            t: "Tjek priser for din destination",
            d: "Priserne varierer meget, bekræft altid for dit land.",
          },
          {
            t: "Saml når det er muligt",
            d: "At kombinere varer i én forsendelse kan være billigere.",
          },
          {
            t: "Tilpas hastighed til hastværk",
            d: "Vælg økonomi til tålmodighed, ekspres kun ved behov.",
          },
        ],
        faq: [
          {
            q: "Hvor meget koster AllChinaBuy forsendelse?",
            a: "Det afhænger af destination, vægt og metode, så tjek aktuelle priser på hovedsiden.",
          },
          {
            q: "Er økonomiforsendelse pålidelig?",
            a: "Normalt pålidelig men langsommere; gennemgå muligheder og tracking før valg.",
          },
          {
            q: "Kan jeg reducere omkostningen?",
            a: "At samle varer og vælge langsommere linjer er to almindelige måder.",
          },
        ],
      },
      "allchinabuy-coupon": {
        title: "AllChinaBuy kupon og rabatkode: Hvor du finder tilbud",
        subtitle:
          "Et realistisk blik på, hvordan AllChinaBuy kuponer og rabatkoder virker, hvor du leder efter dem, og hvordan du undgår at jagte tilbud der ikke findes.",
        metaTitle: "AllChinaBuy kupon og rabatkode: Hvor du finder tilbud",
        metaDescription:
          "Lær hvordan AllChinaBuy kuponer og rabatkoder virker, hvor du finder aktuelle tilbud, og hvordan du bruger dem uden at falde for falske tilbud.",
        metaKeywords:
          "AllChinaBuy kupon, AllChinaBuy rabatkode, AllChinaBuy promokode, AllChinaBuy tilbud",
        tag: "Kuponguide",
        readTime: "4 min læsning",
        intro: [
          "Alle kan lide en rabat, men kuponer på en købsplatform fungerer anderledes end en typisk butik. Tilbud kommer og går, og den bedste kilde er næsten altid selve platformen.",
          "Denne guide forklarer, hvordan AllChinaBuy kuponer og rabatkoder typisk virker, hvor du leder, og hvordan du bruger dem fornuftigt.",
        ],
        sections: [
          {
            h: "Sådan virker kuponer",
            p: [
              "Tilbud kommer typisk i nogle få former: rabatter på hele siden, kategorispecifikke tilbud eller lejlighedsvise koder. De er tidsbegrænsede og skifter ofte.",
            ],
          },
          {
            h: "Hvor du finder aktuelle tilbud",
            p: [
              "Det mest pålidelige sted er hovedsiden, hvor aktive tilbud vises. Kategorilinkene på dette site er et praktisk udgangspunkt.",
            ],
          },
          {
            h: "Undgå falske eller udløbne tilbud",
            p: [
              "Vær forsigtig med tredjeparts kuponsider. Tilbud skifter hurtigt, og en udløbet kode er blot en udløbet kode. Bekræft altid, at en kampagne er aktiv.",
            ],
          },
        ],
        tips: [
          {
            t: "Tjek hovedsiden først",
            d: "Aktive tilbud vises normalt der, hvor du køber.",
          },
          {
            t: "Se efter kategorispecifikke tilbud",
            d: "Nogle rabatter gælder kun bestemte produktgrupper.",
          },
          {
            t: "Byg ikke en plan på en kupon",
            d: "Behandl rabatter som en bonus, ikke en garanti.",
          },
        ],
        faq: [
          {
            q: "Har AllChinaBuy kuponer?",
            a: "Tilbud ændrer sig, tjek hovedsiden for de aktuelle tilbud.",
          },
          {
            q: "Hvor finder jeg AllChinaBuy rabatkoder?",
            a: "Hovedsiden er den mest pålidelige kilde.",
          },
          {
            q: "Er tredjeparts kuponsider troværdige?",
            a: "Vær forsigtig, da tilbud skifter hurtigt og udløbne koder er almindelige.",
          },
        ],
      },
      "allchinabuy-warehouse": {
        title: "AllChinaBuy lager: Sådan virker opbevaring, QC og ordrer",
        subtitle:
          "En klar forklaring på, hvad AllChinaBuy lageret er til, og hvordan opbevaring, kvalitetstjek og klargøring hænger sammen.",
        metaTitle: "AllChinaBuy lager: Sådan virker opbevaring, QC og ordrer",
        metaDescription:
          "Lær hvordan AllChinaBuy lageret virker — hvordan varer modtages, opbevares, kvalitetstjekkes og klargøres til international forsendelse. En enkel guide.",
        metaKeywords:
          "AllChinaBuy lager, AllChinaBuy lagerguide, AllChinaBuy lagerproces",
        tag: "Lagerguide",
        readTime: "6 min læsning",
        intro: [
          "Lageret er det stille mellemtrin i en international ordre. Efter du har købt en vare, går den typisk til et lager, hvor den modtages, opbevares, tjekkes og til sidst pakkes til forsendelse.",
          "Denne guide forklarer, hvad AllChinaBuy lageret gør, og hvordan opbevaring og kvalitetstjek passer ind i din ordre.",
        ],
        sections: [
          {
            h: "Hvad lageret gør",
            p: [
              "Lageret fungerer som et centralt opsamlingspunkt. Varer fra sælgere ankommer her først, hvorefter de registreres, opbevares og kombineres med dine andre køb i én pakke til forsendelse.",
            ],
          },
          {
            h: "Sådan virker opbevaring",
            p: [
              "Købte varer opbevares typisk i et fast vindue, så du kan samle flere ordrer og sende dem sammen. At kombinere er ofte mere økonomisk.",
            ],
          },
          {
            h: "Hvor QC passer ind",
            p: [
              "Lageret er også der, hvor kvalitetstjek normalt sker. Du kan bede om inspektionsfotos, før varerne sendes, for at bekræfte kvaliteten og fange problemer tidligt.",
            ],
          },
        ],
        tips: [
          {
            t: "Forstå opbevaringsvinduet",
            d: "Ved hvor længe varer opbevares, så du kan planlægge samling.",
          },
          {
            t: "Brug QC-fotos før forsendelse",
            d: "Bed om inspektionsfotos for at fange problemer tidligt.",
          },
          {
            t: "Kombinér når det giver mening",
            d: "At sende flere varer sammen er ofte billigere.",
          },
        ],
        faq: [
          {
            q: "Hvad er AllChinaBuy lageret?",
            a: "Det er der, købte varer modtages, opbevares, kvalitetstjekkes og klargøres til international forsendelse.",
          },
          {
            q: "Hvor længe opbevares varer?",
            a: "Vinduer varierer, tjek den aktuelle politik på hovedsiden.",
          },
          {
            q: "Sker QC på lageret?",
            a: "Ja, kvalitetstjek-fotos tages normalt på lageret før forsendelse.",
          },
        ],
      },
      "allchinabuy-legit": {
        title: "Er AllChinaBuy legitimt? En praktisk guide",
        subtitle:
          "Et afbalanceret blik på, hvad det betyder for en købsplatform at være legitim, og hvordan du selv vurderer AllChinaBuy.",
        metaTitle: "Er AllChinaBuy legitimt? En praktisk guide",
        metaDescription:
          "Er AllChinaBuy legitimt? En praktisk og afbalanceret guide til at vurdere platformen — sælgere, produkter, betalinger og forsendelse.",
        metaKeywords:
          "er AllChinaBuy legitimt, AllChinaBuy troværdig, AllChinaBuy sikker at bruge",
        tag: "Legitimitetsguide",
        readTime: "7 min læsning",
        intro: [
          "« Er denne platform legitim? » er et fair spørgsmål, før du bruger penge. Det ærlige svar er, at legitimitet ikke er et simpelt ja eller nej — det afhænger af din brug og din omhu.",
          "Denne guide gennemgår, hvad du bør se på for at afgøre, om AllChinaBuy passer til dig, uden overdrevne påstande i nogen retning.",
        ],
        sections: [
          {
            h: "Hvad « legitim » faktisk betyder",
            p: [
              "En legitim platform tilbyder en reel, fungerende service med gennemsigtige processer. Det er forskelligt fra en garanti for, at hvert produkt eller hver sælger er perfekt.",
            ],
          },
          {
            h: "Hvad du selv bør vurdere",
            p: [
              "De vigtigste tjek er dine egne: gennemgå sælgeroplysninger, se efter QC-fotos, forstå forsendelsesmuligheder og læs politikker for betaling og refusion.",
            ],
          },
          {
            h: "Tegn på en forsigtig tilgang",
            p: [
              "Købere, der tager sig tid, sammenligner og bekræfter detaljer før bestilling, får som regel glattere oplevelser. Der er ingen genvej — beskyttelse kommer af omhu.",
            ],
          },
        ],
        tips: [
          {
            t: "Bekræft før du stoler",
            d: "Tjek sælgeroplysninger og politikker selv i stedet for én kilde.",
          },
          {
            t: "Se efter QC-fotos",
            d: "Kvalitetstjek-billeder er et godt tegn på bekræftelse.",
          },
          {
            t: "Start småt",
            d: "En beskeden første ordre er en lavrisiko måde at lære processen på.",
          },
        ],
        faq: [
          {
            q: "Er AllChinaBuy legitimt?",
            a: "Det er en købsplatform, men du bør altid selv vurdere produkter, sælgere, betalinger og forsendelse.",
          },
          {
            q: "Hvordan tjekker jeg en sælgers troværdighed?",
            a: "Gennemgå sælgeroplysninger, se efter QC-fotos og læs aktuelle politikker.",
          },
          {
            q: "Hvad er den sikreste måde at starte på?",
            a: "Begynd med en lille ordre og bekræft hvert trin.",
          },
        ],
      },
      "allchinabuy-qc": {
        title: "AllChinaBuy QC-guide: Sådan tjekker du produktkvalitet",
        subtitle:
          "Lær hvordan kvalitetskontrol virker på en købsplatform, og hvordan du bruger QC-fotos til at bekræfte, hvad du faktisk får.",
        metaTitle: "AllChinaBuy QC-guide: Sådan tjekker du produktkvalitet",
        metaDescription:
          "En praktisk AllChinaBuy QC-guide. Lær hvordan kvalitetstjek virker, hvordan du anmoder om og læser QC-fotos og fanger problemer før forsendelse.",
        metaKeywords:
          "AllChinaBuy QC, AllChinaBuy QC-fotos, AllChinaBuy kvalitetstjek",
        tag: "QC-guide",
        readTime: "5 min læsning",
        intro: [
          "Kvalitetskontrol, eller QC, er en af de mest nyttige funktioner på en købsplatform — og en af de mest underudnyttede. Det lader dig se din vare, før den sendes, så du kan fange problemer, mens de stadig er nemme at løse.",
          "Denne guide forklarer, hvordan AllChinaBuy QC virker, og hvordan du får mest ud af inspektionsfotos.",
        ],
        sections: [
          {
            h: "Hvad QC faktisk er",
            p: [
              "QC er et tjek før forsendelse, normalt ved at tage billeder af din vare på lageret. Målet er at bekræfte, at varen matcher din ordre, og afsløre tydelige fejl som skader eller forkert størrelse.",
            ],
          },
          {
            h: "Sådan anmoder du om QC-fotos",
            p: [
              "Du kan bede om inspektionsfotos, mens varen er på lageret. Du kan ofte angive bestemte vinkler eller detaljer, nyttigt for pasform, logoer eller syninger.",
            ],
          },
          {
            h: "Sådan læser du billederne",
            p: [
              "Sammenlign billederne med produktopslaget og din ordre. Se efter synlige skader, forkerte detaljer og afvigelser. Hvis noget ser forkert ud, er det nu du skal rejse det — før forsendelse.",
            ],
          },
        ],
        tips: [
          {
            t: "Anmod om QC tidligt",
            d: "Bed om billeder, mens varen stadig er på lageret.",
          },
          {
            t: "Bed om bestemte vinkler",
            d: "Anmod om nærbilleder af logoer eller syninger.",
          },
          {
            t: "Sammenlign med opslaget",
            d: "Tjek billederne mod det, du bestilte.",
          },
        ],
        faq: [
          {
            q: "Hvordan virker AllChinaBuy QC?",
            a: "QC lader dig anmode om inspektionsbilleder før forsendelse for at bekræfte kvaliteten og fange problemer tidligt.",
          },
          {
            q: "Kan jeg bede om bestemte QC-fotos?",
            a: "Ofte ja — du kan bede om bestemte vinkler, mens varen er på lageret.",
          },
          {
            q: "Hvad skal jeg kigge efter i QC-fotos?",
            a: "Synlige skader, forkerte detaljer og afvigelser fra produktopslaget.",
          },
        ],
      },
      "allchinabuy-buying-guide": {
        title: "AllChinaBuy begynderguide",
        subtitle:
          "En trin-for-trin introduktion til nye købere, fra valg af kategori til at gennemføre din første ordre.",
        metaTitle: "AllChinaBuy begynderguide",
        metaDescription:
          "Ny på AllChinaBuy? Denne begynderguide gennemgår valg af kategori, sammenligning, QC og gennemførelse af din første ordre.",
        metaKeywords:
          "AllChinaBuy begynderguide, AllChinaBuy for begyndere, AllChinaBuy købsguide",
        tag: "Begynderguide",
        readTime: "6 min læsning",
        intro: [
          "Er du ny til at købe produkter til international forsendelse, kan processen føles uvant. Den gode nyhed er, at den følger et klart mønster, når du først forstår trinnene.",
          "Denne begynderguide gennemgår en typisk AllChinaBuy-ordre fra start til slut, så du kan føle dig tryg før dit første køb.",
        ],
        sections: [
          {
            h: "Trin 1: Vælg en kategori",
            p: [
              "Start med en kategori, der matcher det du vil have — sko, hættetrøjer, tasker eller andet. At vælge kategori først indsnævrer valgene og forenkler resten.",
            ],
          },
          {
            h: "Trin 2: Sammenlign og lav en kortliste",
            p: [
              "Gennemse varerne og notér dem, du kan lide. Se efter opslag med klare billeder, beskrivelser og kvalitetstjek. En kort liste med to-tre stærke muligheder er bedre end en lang.",
            ],
          },
          {
            h: "Trin 3: Bekræft og bestil",
            p: [
              "Før du bestiller, bekræft de vigtige detaljer — størrelse, forsendelsesmuligheder og QC-fotos. Gennemfør derefter købet på hovedsiden. Et ekstra minut sparer dig for overraskelser.",
            ],
          },
        ],
        tips: [
          {
            t: "Tag det et trin ad gangen",
            d: "Skynd dig ikke — en omhyggelig første ordre lærer dig hele processen.",
          },
          {
            t: "Brug QC på din første ordre",
            d: "Inspektionsfotos er særligt betryggende, når du er ny.",
          },
          {
            t: "Start med velkendte kategorier",
            d: "Vælg varer, du ved hvordan du vurderer.",
          },
        ],
        faq: [
          {
            q: "Hvordan placerer jeg min første AllChinaBuy-ordre?",
            a: "Vælg en kategori, sammenlign, bekræft detaljer, og gennemfør købet på hovedsiden.",
          },
          {
            q: "Skal jeg bruge særlige værktøjer?",
            a: "Nej — du skal bare bruge kategorilinkene og lidt organisering.",
          },
          {
            q: "Er AllChinaBuy godt for begyndere?",
            a: "Ja, især hvis du starter småt og bruger kvalitetstjek-fotos.",
          },
        ],
      },
      "allchinabuy-safe": {
        title: "Er AllChinaBuy sikkert? Guide til tillid og sikkerhed",
        subtitle:
          "Et praktisk blik på, hvordan du shopper sikkert — sælgertjek, betalingsbevidsthed, produktrisiko og forsendelse.",
        metaTitle: "Er AllChinaBuy sikkert? Guide til tillid og sikkerhed",
        metaDescription:
          "Er AllChinaBuy sikkert? En praktisk guide til sikker shopping — sælgertjek, betalinger, produktrisiko og forsendelse forklaret klart.",
        metaKeywords:
          "er AllChinaBuy sikkert, AllChinaBuy sikkerhed, AllChinaBuy sikkerhedsguide",
        tag: "Sikkerhedsguide",
        readTime: "7 min læsning",
        intro: [
          "Sikkerhed handler mindre om selve platformen og mere om din tilgang. Enhver købstjeneste kan bruges omhyggeligt eller skødesløst, og forskellen ligger i nogle få enkle vaner.",
          "Denne guide fokuserer på de praktiske trin til at shoppe sikkert, uden at overdrive eller underdrive risiciene.",
        ],
        sections: [
          {
            h: "Tjek sælgere og opslag",
            p: [
              "Det første sikkerhedslag er din egen gennemgang. Se på sælgeroplysninger, læs beskrivelser og foretræk opslag med QC-fotos. Vage opslag er et tegn på at sænke farten og bekræfte mere.",
            ],
          },
          {
            h: "Vær bevidst om betaling og politikker",
            p: [
              "Forstå hvordan betalinger virker, og læs politikker for refusion og tvister før du bestiller. At kende reglerne på forhånd undgår, at du finder ud af dem under pres.",
            ],
          },
          {
            h: "Håndter produkt- og forsendelsesrisiko",
            p: [
              "Produktkvalitet og forsendelse er de to mest almindelige kilder til overraskelser. Brug QC før forsendelse, og tjek forsendelsesmuligheder og omkostninger for din destination.",
            ],
          },
        ],
        tips: [
          {
            t: "Gennemgå før du køber",
            d: "Få minutters tjek forhindrer de fleste problemer.",
          },
          {
            t: "Forstå politikkerne først",
            d: "Kend reglerne, før du får brug for dem.",
          },
          {
            t: "Brug QC som sikkerhedsnet",
            d: "Inspektionsfotos fanger problemer, mens de kan løses.",
          },
        ],
        faq: [
          {
            q: "Er AllChinaBuy sikkert?",
            a: "Sikkerhed afhænger af din brug. Gennemgå sælgere, betalinger og forsendelse før bestilling.",
          },
          {
            q: "Hvad er den største risiko?",
            a: "Produktkvalitet og forsendelsesomkostninger er de mest almindelige overraskelser.",
          },
          {
            q: "Hvordan beskytter jeg min betaling?",
            a: "Forstå processen og læs politikker for refusion og tvister.",
          },
        ],
      },
    },
  },
};